import PubSub from "underpub-js";
import Slick from "slick-carousel";
import Equalizer from "../../../../scripts/classes/Equalizer";
import { gsap } from "gsap";
import loadTouchEvents from 'jquery-touch-events';
loadTouchEvents($);

var HeroImageSlider = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-HeroImageSlider',
	};

	$.extend(true, this.options, options);

};

HeroImageSlider.prototype.init = function() {

	var self = this;

	this.autoplaySpeed = 8000;
	this.sliderAutoplayInterval = null;
	this.$slideTimerFill = this.options.$el.find(`.${self.options.baseClass}__slideTimerFill`);

	this.slideTimerTween = gsap.fromTo(self.$slideTimerFill,
	{
		right: "100%"
	},
	{
		right: "0%",
		duration: this.autoplaySpeed / 1000, // seconds
		ease: "expo.easeOut",
		paused: true,
		onComplete: function() {
			self.nextSlide();
		},
	});

	// sliders
	this.$imageSlider = this.options.$el.find(`.${self.options.baseClass}__imageBackgroundSlider`);
	this.$contentSlider = this.options.$el.find(`.${self.options.baseClass}__contentSlider`);

	// initialize image slider
	this.$imageSlider.slick({
		arrows: false,
		fade: false,
		speed: 750,
		asNavFor: self.$contentSlider[0],
		swipe: false,
	});

	// initialize text slider
	this.$contentSlider.slick({
		arrows: false,
		fade: true,
		speed: 200,
		asNavFor: self.$imageSlider[0],
		swipe: false,
	});

	// kick off autoplay
	this.startCountdown();

	// swipe events
	this.options.$el.on('swiperight', function() {
		// self.restartAutoplay();
		self.previousSlide();
	});

	this.options.$el.on('swipeleft', function() {
		// self.restartAutoplay();
		self.nextSlide();
	});

	this.options.$el.find(`.${self.options.baseClass}__previousSlide`).on('click', function() {
		// self.restartAutoplay();
		self.previousSlide();
	});

	this.options.$el.find(`.${self.options.baseClass}__nextSlide`).on('click', function() {
		// self.restartAutoplay();
		self.nextSlide();
	});

	// when a slide changes
	this.$imageSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
		self.updateSlideCounter(nextSlide + 1);
	});

	// set up equalizer to set height of slide counter container because children are position: absolute
	this.slideCounterEq = new Equalizer( self.options.$el.find(`.${self.options.baseClass}__slideCounter, .${self.options.baseClass}__slideNumber`) );

	this.slideCounterEq.equalizeHeights();

	PubSub.subscribe("resized", function(){
		self.slideCounterEq.equalizeHeights();
	});

	// pause slider on hover
	this.options.$el.find(`.${self.options.baseClass}__imageBackgroundSliderWrapper`).on('mouseenter', function() {
		self.pauseCountdown();
	});

	this.options.$el.find(`.${self.options.baseClass}__imageBackgroundSliderWrapper`).on('mouseleave', function() {
		self.playCountdown();
	});

};

HeroImageSlider.prototype.startCountdown = function() {

	var self = this;

	this.slideTimerTween.restart();

};

HeroImageSlider.prototype.pauseCountdown = function() {

	var self = this;

	this.slideTimerTween.pause();

};

HeroImageSlider.prototype.playCountdown = function() {

	var self = this;

	this.slideTimerTween.play();

};

HeroImageSlider.prototype.nextSlide = function() {

	var self = this;

	this.$imageSlider.slick('slickNext');
	this.$contentSlider.slick('slickNext');

	if (!this.slideTimerTween.paused())
	{
		console.log('not paused');
		self.startCountdown();
	}
	
};

HeroImageSlider.prototype.previousSlide = function() {

	var self = this;

	this.$imageSlider.slick('slickPrev');
	this.$contentSlider.slick('slickPrev');

	if (!this.slideTimerTween.paused())
	{
		console.log('not paused');
		self.startCountdown();
	}

};

HeroImageSlider.prototype.updateSlideCounter = function(slideNumber){

	var self = this;

	this.options.$el.find(`.${self.options.baseClass}__slideNumber`).removeClass(`${self.options.baseClass}__slideNumber--active`);

	this.options.$el.find(`.${self.options.baseClass}__slideNumber` + '[data-slide-number="' + slideNumber + '"]').addClass(`${self.options.baseClass}__slideNumber--active`);

};

export default HeroImageSlider;
